export enum WatchlistMergeDialogType {
	Local = 1,
	Account = 2
}